import { EMAILRECOVERY_GET, EMAILRECOVERY_UPDATE } from './reduxConstant';

export const emailRecoveryGet = (emailRecovery) => {
  return {
    type: EMAILRECOVERY_GET,
    payload: {
      emailRecovery,
    },
  };
};

export const emailRecoveryUpdate = (emailRecovery) => {
  return {
    type: EMAILRECOVERY_UPDATE,
    payload: {
      emailRecovery,
    },
  };
};
